// export interface TransactionsType {
//   id: number
//   amount: number
//   transaction_type: string
//   solde: number
//   source: string
//   status: string
//   created_at: number
//   client: string
//   invoiceNumber: string
//   note?: string

//   auteur?: {
//     initiator_name: string
//     fonction?: string
//     avatar?: string
//     initiator_email: string

//   }
// }

export type WalletTransactionDirection = "CREDIT" | "DEBIT";
export type WalletTransactionStatus =
  | "PENDING"
  | "IN_PROGRESS"
  | "COMPLETED"
  | "VALIDATED"
  | "FAILED"
  | "CANCELED"
  | "REJECTED";

export type WalletTransactionGateway =
  "FEDAPAY"
  | "STRIPE"
  | "MONEROO"
  | "MANUAL"
  | "INTERNAL";

export type WalletTransactionType =
  "CLIENT_DEPOSIT"
  | "CLIENT_REQUEST"
  | "MANAGER_DEPOSIT"
  |
  "MANAGER_DEBIT"
  | "SYSTEM_REFUND"
  | "MANAGER_REFUND"
  | "SUBSCRIPTION_BILL"
  | "CYCLIC_INVOICE_BILL"
  | "REGULARIZATION_INVOICE_BILL"
  |
  "PARTIAL_CYCLIC_INVOICE_BILL"
  | "PARTIAL_REGULARIZATION_INVOICE_BILL"

export const WALLET_TRANSACTION_DIRECTION_OPTIONS: { value: WalletTransactionDirection; label: string }[] = [{
  value: "CREDIT",
  label: "Crédit",
}, { value: "DEBIT", label: "Débit" }]

export const WALLET_TRANSACTION_STATUS_OPTIONS: { value: WalletTransactionStatus; label: string }[] = [{
  value: "PENDING",
  label: "En attente",
}, { value: "IN_PROGRESS", label: "En cours" }, { value: "COMPLETED", label: "Complété" }, {
  value: "VALIDATED",
  label: "Validé",
}, { value: "FAILED", label: "Échoué" }, { value: "CANCELED", label: "Annulé" }]

export const WALLET_TRANSACTION_TYPE_LABELS: Record<WalletTransactionType, string> = {
  CLIENT_DEPOSIT: "Recharge interne",
  CLIENT_REQUEST: "Demande client",
  MANAGER_DEPOSIT: "Gestionnaire uptimise",
  SYSTEM_REFUND: "Régularisation système",
  MANAGER_REFUND: "Régularisation par un gestionnaire",
  SUBSCRIPTION_BILL: "Facturation abonnement",
  MANAGER_DEBIT: "Débit par un gestionnaire",
  CYCLIC_INVOICE_BILL: "Paiement total de facturation cyclique",
  REGULARIZATION_INVOICE_BILL: "Paiement total de facturation régularisation",
  PARTIAL_CYCLIC_INVOICE_BILL: "Paiement partiel de facturation cyclique",
  PARTIAL_REGULARIZATION_INVOICE_BILL: "Paiement partiel de facturation de régularisation",

}

export type WalletPaymentMethod =
  | "CARD"
  | "MOMO"
  | "BANK_TRANSFER"
  | "CHECK";

export interface WalletTransaction {
  id: string;                // uuid
  reference: string;
  direction: WalletTransactionDirection;
  transaction_type: WalletTransactionType;
  amount: string;            // decimal as string
  currency?: string;
  status?: WalletTransactionStatus;
  payment_method?: WalletPaymentMethod | null;
  has_proof_file?: boolean | null;
  is_requested?: boolean | null;
  company_name: string;
  needs_validation?: boolean | null;
  initiator_email?: string | null;
  initiator_name?: string | null;
  created_at: string;        // date-time
  completed_at?: string | null;
  validated_at?: string | null;
}

export interface DetailedWalletTransaction extends WalletTransaction {
  "validator_email": string | null;
  "validator_name": string | null;
  "invoice_reference": string | null;
  "gateway": WalletTransactionGateway;
  "gateway_transaction_id": string | null;
  "payment_url": string | null;
  "proof_file": string | null;
  "motif": string | null;
  "notes": string | null;
}

export interface StatsRecentWalletTransaction {
  reference: string;
  direction: WalletTransactionDirection;
  client_name: string;
  amount: string;
  status: WalletTransactionStatus;
  duration_since: string;
}